import { render, staticRenderFns } from "./node-area-back.vue?vue&type=template&id=18062fad&scoped=true&"
import script from "./node-area-back.vue?vue&type=script&lang=js&"
export * from "./node-area-back.vue?vue&type=script&lang=js&"
import style0 from "./node-area-back.vue?vue&type=style&index=0&id=18062fad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18062fad",
  null
  
)

export default component.exports